import { render, staticRenderFns } from "./TeamSleepStatusTrendChart.vue?vue&type=template&id=8067a528"
import script from "./TeamSleepStatusTrendChart.vue?vue&type=script&lang=js"
export * from "./TeamSleepStatusTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports